import {
  trackGrowerOpenedRecommendation,
  trackGrowerOpenedRecommendationDDG,
  trackGrowerOpenedRecommendationDirect,
} from './helpers/amplitude';
import track from './amplitudeWrapper';

export const trackSource = (recommendationCropwise: any) => {
  if (recommendationCropwise?.country) {
    const metadata = {
      country: recommendationCropwise.country,
      created_on: recommendationCropwise.created_on,
      email: recommendationCropwise.email_id,
      solution_type: recommendationCropwise.solution_type,
      url: window.location.href,
      year: recommendationCropwise.year,
      summary_area: recommendationCropwise.summary_area,
      application: recommendationCropwise.source,
      totalfields: recommendationCropwise.totalfields,
      solutionId: recommendationCropwise.id,
      organization_id: recommendationCropwise.organization_id,
      crop: recommendationCropwise.recommendations[0]?.crop_type || recommendationCropwise.recommendations[0]?.crop,
    };
    const isDDG = recommendationCropwise.is_ddg;
    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');
    const destParam = urlParams.get('dest');
    if (destParam && destParam.trim().toUpperCase() === 'SMS') {
      track('recommendation opened from sms', {
        'recommendation ID': recommendationCropwise.id,
      });
    }
    if (fromParam && fromParam.trim()) {
      // Case 1: Has "from" parameter - track with Grower name
      trackGrowerOpenedRecommendation(fromParam, metadata);
    } else if (!isDDG) {
      // Case 2: No "from" parameter AND source is not DDG - track TSR opened recommendation
      trackGrowerOpenedRecommendationDirect(metadata);
    } else if (isDDG) {
      // Case 3: Source is DDG - track DDG grower access
      trackGrowerOpenedRecommendationDDG(metadata);
    }
  }
};

